import { render, staticRenderFns } from "./Subscribed.vue?vue&type=template&id=60aa6374&"
import script from "./Subscribed.vue?vue&type=script&lang=js&"
export * from "./Subscribed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports